import * as types from "./actionTypes";
import axios from "axios";
import map from "../map";

export const getType = value => dispatch => {
  const filter = value ? "/" + value : "";
  axios
    .get(process.env.REACT_APP_API_URL + "/search" + filter)
    .then(({ data }) => {
      if (data.status) {
        return dispatch({
          type: types.GET_TYPE,
          data
        });
      }
    });

  return false;
};

export const getFilter = filter => dispatch => {
  return Promise.resolve()
    .then(() =>
      dispatch({
        type: types.GET_FILTER,
        filter
      })
    )
    .then(() => dispatch(map.actions.getLibraries()));
};

export const clearFilter = () => dispatch => {
  return dispatch({
    type: types.CLEAR_FILTER
  });
};



// WEBPACK FOOTER //
// ./src/modules/search/actions.js